import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

/**
 * 特殊的权限包装，如果没有权限，尝试理解跳转集群看板页
 * @param {Object} props
 * @param {string} props.resource 资源
 * @returns
 */
function ClusterListPermWrapper({ perms, children }) {
  const navigate = useNavigate();
  const hasClusterListPerm = perms.includes('pulsar:cluster:cluster_list'); // 有集群列表权限
  const hasClusterPerm = perms.includes('pulsar:cluster'); // 有集群主页权限

  // 有集群权限，但是没有集群列表页权限，有看板权限，则尝试跳转
  useEffect(() => {
    if (hasClusterPerm && !hasClusterListPerm) {
      navigate('/cluster/dashboard');
    }
  }, [navigate, hasClusterListPerm, hasClusterPerm]);

  return hasClusterListPerm ? children : null;
}

export default connect((state) => ({
  perms: state.auth.perms || [],
}))(ClusterListPermWrapper);
